<template>
<div class="capability_maxbox">
    <!-- 分割线 -->
  <div class="cut_off"></div>
  <div class="capability_box">
    <!-- 标题 -->
    <div class="capability_title">平台開放能力</div>
    <!-- 内容-BOX -->
    <div class="capability_content_box">
      <!-- 左点击 -->
      <div class="click_left">
        <img src="../../../assets/img/home/click_left.png" alt="">
      </div>
      <!-- 内容 -->
      <div class="capability">
        <!-- 01 -->
        <div class="capability_no1">
          <img src="../../../assets/img/home/icon_capability01.png" alt="">
          <h3>支付産品</h3>
          <p>
           臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
          </p>
          <div class="more">
            了解詳情
          </div>
        </div>
        <!-- 02 -->
         <div class="capability_no2">
          <img src="../../../assets/img/home/icon_capability02.png" alt="">
          <h3>營運工具</h3>
          <p>
           臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
          </p>
          <div class="more">
            了解詳情
          </div>
        </div>
        <!-- 03 -->
         <div class="capability_no3 active">
          <img src="../../../assets/img/home/icon_capability03.png" alt="">
          <h3>資金管理</h3>
          <p>
           臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
          </p>
          <div class="more">
            了解詳情
          </div>
        </div>
        <!-- 04 -->
         <div class="capability_no4">
          <img src="../../../assets/img/home/icon_capability04.png" alt="">
          <h3>拓展工具</h3>
          <p>
            臺易購提供您至少五種以上支付工具，讓你輕鬆跨平台使用，無論商家開店、個人使用均無往不利，無痛管理！
          </p>
          <div class="more">
            了解詳情
          </div>
        </div>
      </div>
      <!-- 右点击 -->
      <div class="click_right">
        <img src="../../../assets/img/home/click_right.png" alt="">
      </div>
    </div>
    <div class="cut_off"></div>
  </div>
</div>
</template>

<script>
export default {
  name: 'HomeCapability',
  props: {
  },
  data() {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .capability_box {
    font-size: 27px;
    color: #000000;
    text-align: center;
    /* min-width: 880px; */
  }
  .cut_off {
    background: #e8e8e8;
    height: 2px;
    margin: 40px 174px;
  }
  .capability_title {
    margin-bottom: 57px;
    font-weight: bold;
    min-width: 1000px;
  }
  .capability_content_box {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .capability_content_box .click_left {
    margin-left: 54px;
    margin-right: 36px;
  }
  .capability_content_box .click_right {
    margin-left: 36px;
    margin-right: 54px;
  }
  .capability {
    flex: 1;
    display: flex;
  }
  .capability > div {
    cursor: pointer;
    box-sizing: border-box;
    flex: 1;
    padding: 0 2 25px;
    height: 400px;
    overflow: hidden;
    border: 5px solid transparent;
    margin: 0 5px;
    /* border: 8px solid #000000; */
  }
  .capability > div:hover {
    border: 5px solid black;
  }
  .capability .active {
    /* border: 3px solid #000000; */
  }
  .capability img {
    margin-top: 50px;
    margin-bottom: 30px;

  }
  .capability h3 {
    font-size: 17px;
  }
  .capability p {
    font-size: 11px;
    height: 50px;
    text-align: center;
    line-height: 18px;
    padding: 28px 28px;

  }
  .capability .more {
    font-size: 11px; 
    font-weight: bold;
    border-bottom: 1px solid ;
    display: inline;
  }



    /*  */
@media screen and (max-width:768px){
  /* 显示/隐藏 */
  .capability_maxbox {
    display: none;
  }
}

</style>
